<script>
  import { Badge } from 'element-ui'
  export default {
    name:'ElBadge',
    extends:Badge
  }
</script>
